import { observer } from 'mobx-react-lite'
import { DS } from '../../design-system'
import { StyleSheet, TouchableOpacity } from 'react-native'
import { useStore } from '../../models'
import * as Progress from 'react-native-progress'
import { useRouter } from 'expo-router'

export const CompleteYourProfile = observer(() => {
  const store = useStore()
  const router = useRouter()
  const answeredQuestions = store.session.onboardingProgress?.answeredQuestions
  const totalQuestions = store.session.onboardingProgress?.totalQuestions
  // we add 1 here for the "name question"
  const answeredSteps = answeredQuestions ? answeredQuestions + 1 : 1
  const totalSteps = totalQuestions ? totalQuestions + 1 : 5

  const handlePress = () => {
    router.navigate('/onboarding/name?isResuming=true')
  }

  const progressValue = answeredSteps / totalSteps

  return (
    <DS.Frame style={styles.container}>
      <DS.Frame style={styles.textContainer}>
        <DS.Frame>
          <DS.Text variant="Heading 5/Medium" style={{ paddingBottom: 4 }}>
            Complete Your Profile
          </DS.Text>
        </DS.Frame>
        <DS.Frame style={styles.progressContainer}>
          <DS.Frame style={styles.stepsContainer}>
            <DS.Text variant="Caption/Medium" color={'Utility/Success'}>
              {totalSteps - answeredSteps} steps left
            </DS.Text>
          </DS.Frame>
          <DS.Frame>
            <Progress.Bar
              borderWidth={0}
              borderRadius={0}
              borderColor="gray"
              progress={progressValue}
              animated={true}
              unfilledColor="lightgray"
              color={DS.palette['Utility/Success']}
              height={4}
            />
          </DS.Frame>
        </DS.Frame>
        <DS.Frame>
          <DS.Text variant="Body Small/Regular">The more info we collect, the more we can cater to your needs.</DS.Text>
        </DS.Frame>
      </DS.Frame>
      <TouchableOpacity onPress={handlePress} style={styles.iconContainer}>
        <DS.Icon name="Arrow--right-enclosed" size={48} />
      </TouchableOpacity>
    </DS.Frame>
  )
})

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 8,
    padding: 16,
    gap: 16
  },
  stepsContainer: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    gap: 8
  },
  progressContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5
  },
  textContainer: {
    maxWidth: '80%',
    gap: 5
  },
  iconContainer: {
    justifyContent: 'center'
  }
})
